import { type AdminMode } from "@/hooks/useAdminMode";
import { Shield, Home, Award } from "lucide-react";

interface ModeSwitcherProps {
  activeMode: AdminMode;
  onSwitch: (mode: AdminMode) => void;
}

const modeConfig: Record<AdminMode, { label: string; icon: React.ComponentType<{ className?: string }> }> = {
  admin: { label: "Admin", icon: Shield },
  owner: { label: "Owner", icon: Home },
  agent: { label: "Agent", icon: Award },
};

export function ModeSwitcher({ activeMode, onSwitch }: ModeSwitcherProps) {
  return (
    <div className="flex gap-0.5 bg-white/5 rounded-lg p-0.5">
      {(["admin", "owner", "agent"] as AdminMode[]).map((mode) => {
        const { label, icon: Icon } = modeConfig[mode];
        const isActive = mode === activeMode;
        return (
          <button
            key={mode}
            onClick={() => onSwitch(mode)}
            className={`flex-1 flex items-center justify-center gap-1 px-2 py-1.5 rounded text-[11px] font-medium transition-colors ${
              isActive
                ? "bg-gold/20 text-sun"
                : "text-white/50 hover:text-white/70 hover:bg-white/5"
            }`}
          >
            <Icon className="h-3 w-3 shrink-0" />
            {label}
          </button>
        );
      })}
    </div>
  );
}
